import { render, staticRenderFns } from "./IntroVideo.vue?vue&type=template&id=0bcbb59f&scoped=true&"
import script from "./IntroVideo.vue?vue&type=script&lang=js&"
export * from "./IntroVideo.vue?vue&type=script&lang=js&"
import style0 from "./IntroVideo.vue?vue&type=style&index=0&id=0bcbb59f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcbb59f",
  null
  
)

export default component.exports